// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Limits tab — aligned with LicenseTable */

.ll-page {
  min-height: 100%;
}

.ll-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.ll-toolbar-note {
  font-size: 15px;
  color: #94a3b8;
}

.ll-btn-refresh {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.ll-btn-refresh:hover {
  background: #f8fafc;
}

.ll-toast {
  font-size: 15px;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ll-toast--ok {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #bbf7d0;
}

.ll-toast--err {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.ll-toast button {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: inherit;
  opacity: 0.7;
}

.ll-table-wrap {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.ll-table-scroll {
  overflow-x: auto;
}

.ll-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 15px;
}

.ll-table thead th {
  padding: 9px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #fafbfc;
  border-bottom: 1px solid #e2e8f0;
}

.ll-table thead th:nth-child(1) { width: 28%; }
.ll-table thead th:nth-child(3) { width: 14%; }
.ll-table thead th:nth-child(4) { width: 18%; }
.ll-table thead th:last-child { width: 36px; }

.ll-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
  color: #334155;
}

.ll-table tbody tr {
  cursor: pointer;
  transition: background 0.12s;
}

.ll-table tbody tr:hover {
  background: #f8fafc;
}

.ll-table tbody tr:last-child td {
  border-bottom: none;
}

.ll-org-name {
  display: block;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ll-org-email {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ll-text-muted {
  font-size: 15px;
  color: #64748b;
}

.ll-limits {
  font-size: 15px;
  color: #64748b;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.ll-limits strong {
  color: #334155;
  font-weight: 600;
}

.ll-ui-summary {
  font-size: 15px;
  color: #64748b;
  line-height: 1.35;
}

.ll-ui-summary span {
  color: #475569;
}

.ll-icon-edit {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ll-table tbody tr:hover .ll-icon-edit {
  color: #94a3b8;
}

.ll-icon-edit:hover {
  background: #f1f5f9;
  color: #475569;
}

.ll-empty {
  padding: 40px 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.ll-loading {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.ll-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  font-size: 15px;
  color: #64748b;
}

.ll-pagination-btns {
  display: flex;
  gap: 6px;
}

.ll-page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  color: #64748b;
  font-size: 15px;
  cursor: pointer;
}

.ll-page-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.ll-page-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Edit modal */
.ll-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  padding: 16px;
}

.ll-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 440px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
  border: 1px solid #e2e8f0;
}

.ll-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.ll-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.ll-modal-email {
  font-size: 15px;
  color: #94a3b8;
  margin: 2px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ll-modal-close {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ll-modal-body {
  padding: 14px 16px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.ll-field {
  margin-bottom: 12px;
}

.ll-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
}

.ll-field select,
.ll-field input[type="number"] {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  color: #0f172a;
  background: #fff;
  box-sizing: border-box;
}

.ll-field select:focus,
.ll-field input:focus {
  outline: none;
  border-color: #93c5fd;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.12);
}

.ll-num-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

.ll-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 12px;
}

.ll-toggle-label {
  font-size: 15px;
  color: #334155;
  font-weight: 500;
}

.ll-toggle-hint {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
  margin-top: 2px;
}

.ll-switch {
  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
}

.ll-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.ll-switch-slider {
  position: absolute;
  inset: 0;
  background: #cbd5e1;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.2s;
}

.ll-switch-slider::before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  left: 2px;
  top: 2px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.ll-switch input:checked + .ll-switch-slider {
  background: #2563eb;
}

.ll-switch input:checked + .ll-switch-slider::before {
  transform: translateX(18px);
}

.ll-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
}

.ll-btn-cancel {
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.ll-btn-save {
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  background: #2563eb;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.ll-btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ll-page-loading {
  padding: 48px;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}

.animate-spin {
  animation: ll-spin 0.8s linear infinite;
}

@keyframes ll-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/LicenseLimitsPage.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,UAAU,EAAE;AAC9C,gCAAgC,WAAW,EAAE;;AAE7C;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Limits tab — aligned with LicenseTable */\n\n.ll-page {\n  min-height: 100%;\n}\n\n.ll-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.ll-toolbar-note {\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.ll-btn-refresh {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ll-btn-refresh:hover {\n  background: #f8fafc;\n}\n\n.ll-toast {\n  font-size: 15px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.ll-toast--ok {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #bbf7d0;\n}\n\n.ll-toast--err {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.ll-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.ll-table-wrap {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n.ll-table-scroll {\n  overflow-x: auto;\n}\n\n.ll-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 15px;\n}\n\n.ll-table thead th {\n  padding: 9px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: #fafbfc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.ll-table thead th:nth-child(1) { width: 28%; }\n.ll-table thead th:nth-child(3) { width: 14%; }\n.ll-table thead th:nth-child(4) { width: 18%; }\n.ll-table thead th:last-child { width: 36px; }\n\n.ll-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n  color: #334155;\n}\n\n.ll-table tbody tr {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.ll-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.ll-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.ll-org-name {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ll-org-email {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ll-text-muted {\n  font-size: 15px;\n  color: #64748b;\n}\n\n.ll-limits {\n  font-size: 15px;\n  color: #64748b;\n  font-variant-numeric: tabular-nums;\n}\n\n.ll-limits strong {\n  color: #334155;\n  font-weight: 600;\n}\n\n.ll-ui-summary {\n  font-size: 15px;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.ll-ui-summary span {\n  color: #475569;\n}\n\n.ll-icon-edit {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #cbd5e1;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ll-table tbody tr:hover .ll-icon-edit {\n  color: #94a3b8;\n}\n\n.ll-icon-edit:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.ll-empty {\n  padding: 40px 16px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.ll-loading {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n.ll-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 10px;\n  font-size: 15px;\n  color: #64748b;\n}\n\n.ll-pagination-btns {\n  display: flex;\n  gap: 6px;\n}\n\n.ll-page-btn {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  color: #64748b;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.ll-page-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.ll-page-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Edit modal */\n.ll-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  padding: 16px;\n}\n\n.ll-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 440px;\n  max-height: calc(100vh - 32px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e2e8f0;\n}\n\n.ll-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.ll-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.ll-modal-email {\n  font-size: 15px;\n  color: #94a3b8;\n  margin: 2px 0 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ll-modal-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ll-modal-body {\n  padding: 14px 16px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.ll-field {\n  margin-bottom: 12px;\n}\n\n.ll-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 5px;\n}\n\n.ll-field select,\n.ll-field input[type=\"number\"] {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #0f172a;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.ll-field select:focus,\n.ll-field input:focus {\n  outline: none;\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.12);\n}\n\n.ll-num-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.ll-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.ll-toggle-label {\n  font-size: 15px;\n  color: #334155;\n  font-weight: 500;\n}\n\n.ll-toggle-hint {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 400;\n  margin-top: 2px;\n}\n\n.ll-switch {\n  position: relative;\n  width: 40px;\n  height: 22px;\n  flex-shrink: 0;\n}\n\n.ll-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.ll-switch-slider {\n  position: absolute;\n  inset: 0;\n  background: #cbd5e1;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.ll-switch-slider::before {\n  content: '';\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  left: 2px;\n  top: 2px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n\n.ll-switch input:checked + .ll-switch-slider {\n  background: #2563eb;\n}\n\n.ll-switch input:checked + .ll-switch-slider::before {\n  transform: translateX(18px);\n}\n\n.ll-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.ll-btn-cancel {\n  padding: 8px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ll-btn-save {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 8px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ll-btn-save:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ll-page-loading {\n  padding: 48px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.animate-spin {\n  animation: ll-spin 0.8s linear infinite;\n}\n\n@keyframes ll-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
